<template>
<div class="new-body new-form">
    <div class="new-content new-inr">
        <header class="form-header">
            <div class="register_history_back">
                <img src="@/assets/images/ex-show@2x.png" style="width:15px;" @click="goToBack()">
            </div>
            <span>
                <h1>고시락 고시원 신규 등록</h1>
            </span>
        </header>
        <main id="new-container" class="new-form-container">
            <figure class="form-logo">
                <img src="@/assets/new_images/form-logo.png" alt="고시락 로고" class="logo">
            </figure>
            <form>
                <div class="d-flex">
                    <!-- <div class="input-wrap error" -->
                    <div class="input-wrap" id="name">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">고시원명</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        고시원명이 ‘휴식 노원점’인 경우 고시원명에 휴식, 지점명에 노원점 또는 노원역을 입력해주세요.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="text" placeholder="고시원명을 입력해주세요." v-model="kosiwon.name" />
                    </div>
                    <div class="input-wrap">
                        <label>
                            <strong class="label-text">지점명</strong>
                        </label>
                        <input type="text" placeholder="지점명을 입력해주세요." v-model="kosiwon.branch" />
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="address_brief">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">주소</strong>
                        </label>
                        <input type="text" placeholder="클릭하여 주소를 검색해주세요." v-model="kosiwon.address_brief" readonly @click="openSearchAddress()" />
                    </div>
                    <div class="input-wrap" id="address_detail">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">상세 주소</strong>
                        </label>
                        <input type="text" placeholder="상세주소를 입력해주세요. (Ex : 3층)" v-model="kosiwon.address_detail" />
                    </div>
                </div>
                <div class="information-box-1">
                    <div class="d-flex">
                        <figure>
                            <img src="@/assets/new_images/icon-message.png" alt="말풍선">
                        </figure>
                        <p>
                            지속적으로 “해당 주소는 Daum 지도에 표시되지 않아 위도/경도 값을 가져올 수 없습니다.” 라는 문구가 뜨게 된다면 <a :href="chromeCacheOrCookieResetUrl">크롬 캐시 삭제 가이드</a>를 참고하여 진행 후 다시 시도해주세요.
                        </p>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="owner_name">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">원장님 성함</strong>
                        </label>
                        <input type="text" placeholder="원장님 성함을 입력해주세요." v-model="kosiwon.owner_name" />
                    </div>
                    <div class="input-wrap" id="company_registration_number">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">사업자 번호</strong>
                        </label>
                        <input type="text" placeholder="사업자 번호를 입력해주세요." v-model="kosiwon.company_registration_number" />
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="phone_no">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">고시원 유선번호</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        입력하신 유선번호를 기반으로 고시락에서 가상번호를 제공하며, 해당 번호로 입실자들이 고시원에 입실 문의가 이루어집니다. 만약에 유선번호가 없을 시, 담당자 휴대폰 번호를 입력해주세요.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="text" placeholder="고시원 유선번호를 입력해주세요." v-model="kosiwon.phone_no" />
                    </div>
                    <div class="input-wrap" id="cellphone_no">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">담당자 휴대폰 번호</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        입력하신 담당자 휴대폰 번호를 기반으로 입실 문의 문자/카카오톡이 발송됩니다.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="text" placeholder="고시원 담당자 휴대폰 번호를 입력해주세요." v-model="kosiwon.cellphone_no" />
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="price">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">가격 정보 (만원)</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        최소 금액, 최대 금액을 만원 단위로 입력해주세요. 또한 가격에 0보다 작은 값을 입력할 수 없으며, 최소 금액은 최대 금액보다 클 수 없습니다.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <div class="d-flex">
                            <input type="number" placeholder="최소 금액 (35)" min="0" v-model="kosiwon.price_min" style="margin-right:10px" />
                            <input type="number" placeholder="최대 금액 (40)" min="0" v-model="kosiwon.price_max" />
                        </div>
                    </div>
                    <div class="input-wrap" id="deposit">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">보증금 (만원)</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        보증금을 만원 단위로 입력해주세요. 보증금이 0일 경우 보증금 없음으로 적용됩니다. 또한 0보다 작은 값을 입력할수 없습니다.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="number" placeholder="보증금을 입력해주세요." min="0" v-model="kosiwon.deposit" />
                    </div>
                </div>
                <div class="d-flex">
                    <div class="input-wrap" id="floor">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">층 수</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        ‘층’을 제외한 숫자 값만 입력해주세요. 2~3층에 고시원을 운영중인 경우, 2~3 입력해주세요.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <div class="d-flex">
                            <input type="text" placeholder="고시원 층수 (2 or 2~3)" v-model="kosiwon.floor" style="margin-right:10px" />
                            <input type="text" placeholder="건물 총 층 수 (4)" v-model="kosiwon.building_floor" />
                        </div>
                    </div>
                    <div class="input-wrap">
                        <label>
                            <strong class="label-text">홈페이지 URL</strong>
                        </label>
                        <input type="text" placeholder="홈페이지 URL을 입력해주세요." v-model="kosiwon.url" />
                    </div>
                </div>
                <div class="input-wrap">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">사용자 구분</strong>
                    </label>
                    <div class="d-flex" style="flex-wrap:wrap; padding:10px 0 0 0">
                        <span class="checkbox-button" v-for="(type, idx) in useSexType_options" :key="`useSexType_${idx}`" :class="{checked:type.checked}" @click="changeType(type, 'useSexType_options')">
                            <input type="checkbox" />
                            <label>
                                <span class="checkmark"></span>
                                {{ type.text }}
                            </label>
                        </span>
                    </div>
                </div>
                <div class="input-wrap">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">난방 타입</strong>
                    </label>
                    <div class="d-flex" style="flex-wrap:wrap; padding:10px 0 0 0">
                        <span class="checkbox-button" v-for="(type, idx) in heatingType_options" :key="`heatingType_${idx}`" :class="{checked:type.checked}" @click="changeType(type, 'heatingType_options')">
                            <input type="checkbox" />
                            <label>
                                <span class="checkmark"></span>
                                {{ type.text }}
                            </label>
                        </span>
                    </div>
                </div>
                <div class="input-wrap">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">룸 타입 (다중 선택 가능)</strong>
                    </label>
                    <div class="d-flex" style="flex-wrap:wrap; padding:10px 0 0 0">
                        <span class="checkbox-button" v-for="(type, idx) in roomType_options" :key="`roomType_${idx}`" :class="{checked:type.checked}">
                            <input type="checkbox" v-model="type.checked" />
                            <label>
                                <span class="checkmark"></span>
                                {{ type.text }}
                            </label>
                        </span>
                    </div>
                </div>
                <div class="input-wrap">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">고시원 옵션 (다중 선택 가능)</strong>
                    </label>
                    <div class="d-flex check-5" style="flex-wrap:wrap; padding:10px 0 0 0">
                        <span class="checkbox-button" style="width:calc(100%/5 - 10px); flex: none" v-for="(type, idx) in options" :key="`options_${idx}`" :class="{checked:type.checked}">
                            <input type="checkbox" v-model="type.checked" />
                            <label>
                                <span class="checkmark"></span>
                                {{ type.text }}
                            </label>
                        </span>
                    </div>
                </div>
                <div class="input-wrap" id="intro">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">고시원 한 줄 소개</strong>
                        <span class="inform">
                            <a class="tooltip-wrap">
                                <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                <span class="tooltip-content">
                                    <img :src="intro.image_url" alt="고시원 한 줄 소개" style="display:block; height:229px; width:193px; margin:0 auto">
                                    {{ intro.text }}
                                </span>
                            </a>
                        </span>
                    </label>
                    <span style="font-size:14px; color:#666; margin:15px 0; opacity: 0.7; display:block;" v-html="intro.example"></span>
                    <input type="text" placeholder="고시원 한 줄 소개를 자유롭게 입력해주세요." v-model="kosiwon.intro" />
                </div>
                <div class="input-wrap" id="description">
                    <label>
                        <span class="ast">*</span>
                        <strong class="label-text">고시원 상세 설명</strong>
                        <span class="inform">
                            <a class="tooltip-wrap">
                                <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                <span class="tooltip-content">
                                    <img :src="description.image_url" alt="고시원 상세 설명" style="display:block; height:229px; width:193px; margin:0 auto">
                                    {{ description.text }}
                                </span>
                            </a>
                        </span>
                    </label>
                    <span style="font-size:14px; color:#666; margin:15px 0; opacity: 0.7; display:block;" v-html="description.example"></span>
                    <textarea placeholder="고시원 상세 설명을 자유롭게 입력해주세요." rows=12 v-model="kosiwon.description"></textarea>
                </div>
                <div class="input-wrap" style="margin-bottom: 50px;">
                    <label>
                        <strong class="label-text">지하철</strong>
                        <span class="inform">
                            <a class="tooltip-wrap">
                                <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                <span class="tooltip-content">
                                    고시원 근처에 위치한 역이 노원역인 경우 ‘노원’만 입력해주세요. 또한 지하철 정보는 최대 2개까지 입력 가능합니다.
                                </span>
                            </a>
                        </span>
                    </label>
                    <span class="subway-wrap" @click="addSubway()">
                        <figure>
                            <img src="@/assets/new_images/icon-subway.png" alt="subway">
                        </figure>
                        <small>지하철 추가</small>
                    </span>
                </div>
                <div>
                    <div class="input-wrap subway-select-content" v-if="kosiwon.traffics_subway.length > 0">
                        <label>
                            <strong class="label-text">지하철 정보를 입력해주세요.</strong>
                        </label>
                        <div class="d-flex subway-select-wrap" v-for="(subway, idx) in kosiwon.traffics_subway" :key="`subway_${idx}`">
                            <select :id="`subway_${idx}`" style="width:100%; height:45px; border-bottom:1px solid #eee; outline:none; padding:12px 0;" v-model="subway.station_number">
                                <option value="" disabled selected>지하철 호선</option>
                                <option v-for="(line) in subwayLine_list" :value="line">
                                    {{ line }}
                                </option>
                            </select>
                            <input type="text" placeholder="역 이름을 입력해주세요." style="display:block; margin-left:10px" v-model="subway.intro" />
                            <button class="delete" :key="`subway_delete_${idx}`" onclick="return false;" @click="delSubway(idx)">
                                <img src="@/assets/new_images/icon-trash.png">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="photo-wrap" style="margin-bottom: 50px;">
                    <div class="input-wrap">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">고시원 썸네일</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        <img :src="thumbnail.image_url" alt="고시원 한 줄 소개" style="display:block; height:229px; width:193px; margin:0 auto">
                                        {{ thumbnail.text }}
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="text" placeholder="파일을 선택해 주세요" readonly @click="openUpload(`thumnauilFile`)" />
                        <input type="file" id="thumnauilFile" accept="image/*" style="display:none;" @change="selectThumbnailImage($event)" />
                        <button onclick="return false;" @click="openUpload(`thumnauilFile`)">파일 선택</button>
                    </div>
                    <div class="thumb-nail" v-if="kosiwon.thumbnail_url">
                        <figure>
                            <img :src="kosiwon.thumbnail_url">
                        </figure>
                        <button class="delete" onclick="return false;" @click="delThumbnailImage()">
                            <img src="@/assets/new_images/icon-trash.png" alt="trash">
                        </button>
                    </div>
                </div>
                <div class="photo-wrap">
                    <div class="input-wrap">
                        <label>
                            <span class="ast">*</span>
                            <strong class="label-text">고시원 사진 정보 (10장 이내)</strong>
                            <span class="inform">
                                <a class="tooltip-wrap">
                                    <img src="@/assets/new_images/icon-inform.png" alt="inform icon">
                                    <span class="tooltip-content">
                                        고시원 상세 보기 시, 상단의 이미지에 적용됩니다.
                                    </span>
                                </a>
                            </span>
                        </label>
                        <input type="text" placeholder="파일을 선택해 주세요" readonly @click="openUpload(`kosiwonFile`)" />
                        <input type="file" id="kosiwonFile" accept="image/*" style="display:none;" @change="selectKosiwonImage($event)" multiple />
                        <button onclick="return false;" @click="openUpload(`kosiwonFile`)">파일 선택</button>
                    </div>
                    <ul class="photo-lists" v-if=kosiwon_image_files.length>
                        <li class="photo-list" v-for="(item, idx) in kosiwon_image_files" :key="`kosiwon_image_${idx}`">
                            <figure>
                                <img :src="item.image_url" :class="{'img-vertical' : item.vertical}">
                            </figure>
                            <div class="button-wrap">
                                <input type="file" :id="`kosiwonFile_${idx}`" accept="image/*" style="display:none;" @change="selectKosiwonImage($event, idx)" />
                                <button class="edit" onclick="return false;" @click="openUpload(`kosiwonFile_${idx}`)">
                                    <img src="@/assets/new_images/icon-pen.png" alt="edit">
                                </button>
                                <button class="delete" onclick="return false;" @click="delKosiwonImage(idx)">
                                    <img src="@/assets/new_images/icon-trash.png" alt="trash">
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="information-box">
                    <h3>고시락 신규 등록 안내 사항</h3>
                    <ul class="information-lists">
                        <li class="information-list">
                            <figure>
                                <img src="@/assets/new_images/icon-email.png" alt="email">
                            </figure>
                            <p>
                                <a href="mailto: kosirock.winni@gmail.com">kosirock.winni@gmail.com</a>
                            </p>
                        </li>
                        <li class="information-list">
                            <figure>
                                <img src="@/assets/new_images/icon-phone.png" alt="phone">
                            </figure>
                            <p>
                                <a href="tel:02-911-9051">02-911-9051</a>
                            </p>
                        </li>
                        <li class="information-list">
                            <figure>
                                <img src="@/assets/new_images/icon-information.png" alt="information">
                            </figure>
                            <p>
                                고시원 신규 등록 신청 후, 고시원 존재 여부 / 내용 검수 등을 통해서 승인 처리시간이 소요될 수 있습니다.
                                <strong>승인이 완료되면 원장님께 문자가 발송됩니다.</strong>
                            </p>
                        </li>
                        <li class="information-list">
                            <figure>
                                <img src="@/assets/new_images/icon-message.png" alt="message">
                            </figure>
                            <p>
                                <strong>단, 무료 등록에는 제한이 있을 수 있습니다. </strong>
                                &nbsp;무료 등록 시, 문의 및 사용에 제한이 따를 수 있으며 패키지 가입 요청을 드릴 수 있습니다.
                                &nbsp;또한, 고시원이 존재하지 않거나 부적절한 내용이 포함될 경우 승인이 거절될 수 있습니다.
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="submit-button-wrap" v-if="!isLoading">
                    <button class="submit" onclick="return false;" @click="saveKosiwon()">신청하기</button>
                </div>
                <div class="submit-button-wrap" v-else>
                    <button class="submit" onclick="return false;">등록 중...</button>
                </div>
            </form>
        </main>
        <div class="loading-wrap">
            <svg class="tea" width="37" height="48" viewbox="0 0 37 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.0819 17H3.02508C1.91076 17 1.01376 17.9059 1.0485 19.0197C1.15761 22.5177 1.49703 29.7374 2.5 34C4.07125 40.6778 7.18553 44.8868 8.44856 46.3845C8.79051 46.79 9.29799 47 9.82843 47H20.0218C20.639 47 21.2193 46.7159 21.5659 46.2052C22.6765 44.5687 25.2312 40.4282 27.5 34C28.9757 29.8188 29.084 22.4043 29.0441 18.9156C29.0319 17.8436 28.1539 17 27.0819 17Z" stroke="var(--secondary)" stroke-width="2"></path>
                <path d="M29 23.5C29 23.5 34.5 20.5 35.5 25.4999C36.0986 28.4926 34.2033 31.5383 32 32.8713C29.4555 34.4108 28 34 28 34" stroke="var(--secondary)" stroke-width="2"></path>
                <path id="teabag" fill="var(--secondary)" fill-rule="evenodd" clip-rule="evenodd" d="M16 25V17H14V25H12C10.3431 25 9 26.3431 9 28V34C9 35.6569 10.3431 37 12 37H18C19.6569 37 21 35.6569 21 34V28C21 26.3431 19.6569 25 18 25H16ZM11 28C11 27.4477 11.4477 27 12 27H18C18.5523 27 19 27.4477 19 28V34C19 34.5523 18.5523 35 18 35H12C11.4477 35 11 34.5523 11 34V28Z">
                </path>
                <path id="steamL" d="M17 1C17 1 17 4.5 14 6.5C11 8.5 11 12 11 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="var(--secondary)"></path>
                <path id="steamR" d="M21 6C21 6 21 8.22727 19 9.5C17 10.7727 17 13 17 13" stroke="var(--secondary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            chromeCacheOrCookieResetUrl: "https://support.google.com/accounts/answer/32050?hl=ko&co=GENIE.Platform%3DDesktop",

            intro: {
                example: "<예시><br />" +
                    "23 년 3월 오픈! 논현역 도보 8분 프리미엄 레지던스 휴식 논현점 ",
                image_url: "https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/9ad2292659d7a194feee76fdd3e0e0eea2dd322d521443488d6ab7eaef887238.png",
                text: "고시원 지도 검색 시, 한 줄 소개에 적용됩니다."
            },

            description: {
                example: "<예시><br />" +
                    "프리미엄 레지던스 휴식은? <br />" +
                    "- 고시락이 제공하는 1인 주거공간 프리미엄 레지던스 휴식입니다. <br /><br />" +
                    "개인 시설 <br />" +
                    "- 각 방마다 유선방송 무료 시청가능한 TV 설치 <br />" +
                    "- 침대, 책상, 책꽂이, 옷장, 미니 냉장고 풀옵션<br />" +
                    "- 초고속 인터넷 및 Wi-Fi 설치<br />" +
                    "- 욕실/화장실 구비되어있는 원룸<br /><br />" +
                    "공용 시설<br />" +
                    "- 주방 : 김치냉장고, 정수기, 전자레인지<br />" +
                    "- 세탁실 및 다림질실<br />" +
                    "- 소화기 및 화재 감지 시스템<br />" +
                    "- 밥, 김치, 라면, 계란, 커피, 녹차 무료제공",
                image_url: "https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/bbd66a1984d15054e3b070983552758b3b6ef03c89a5c73a02779a6ad22aa175.png",
                text: "고시원 상세 보기 시, 소개란에 적용됩니다."
            },

            thumbnail: {
                image_url: "https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/9656ed484072f2157691ff713207d2f94827b4e18c3f0c2887093bf0660f138e.png",
                text: "고시원 지도 검색 시, 썸네일 이미지에 적용됩니다. 가급적이면 방 사진을 등록해주시기 바랍니다."
            },

            kosiwon_image_files: [],

            kosiwon: {
                name: "",
                branch: "",

                address_brief: "", // 주소
                address_detail: "", // 상세주소,
                lat: null, // 위도
                lng: null, // 경도

                owner_name: "", // 업주이름
                company_registration_number: "", // 사업자번호,

                phone_no: "", // 유선번호
                cellphone_no: "", // 담당자 핸드폰번호,

                price_min: "", // 최소 금액
                price_max: "", // 최대 금액
                deposit: 0, // 보증금,

                floor: "", // 고시원 층수
                building_floor: "", // 건물 전체 층수
                url: "", // 홈페이지 URL,

                heating_type: "N", // 난방정보 (default 없음)
                room_type: "", // 룸 타입 (default 없음)
                options: {
                    // use_sex_type: "U", // 사용자 구분
                },

                intro: "",
                description: "", // 상세 설명

                traffics_subway: [], // 지하철 정보

                thumbnail_url: null, // 썸네일 이미지 (고시락 메인 썸네일 / 지도 검색 썸네일)
                categories: [{
                    category_name: "기본",
                    groups: [{
                        group_name: "기본",
                        images: []
                    }]
                }],

                private_memo: "", // 비공개 메모
                manager_phone_no: "", // 총무 핸드폰번호
                kakao_talk_receiver: "W", // 카카오 알림톡 대상 (default 원장)
                package_type: "N", // 패키지 타입 (default 없음)
                package_renew_month: 0, // 패지키 갱신주기
                package_register_date: null, // 패키지 계약 시작일
                package_end_date: null, // 패키지 계약 종료일
            },

            useSexType_options: [{
                    value: "U",
                    text: "남녀 공용",
                    checked: true
                },
                {
                    value: "S",
                    text: "남녀 층 분리",
                    checked: false
                },
                {
                    value: "M",
                    text: "남성 전용",
                    checked: false
                },
                {
                    value: "W",
                    text: "여성 공용",
                    checked: false
                }
            ],

            heatingType_options: [{
                    value: "N",
                    text: "없음",
                    checked: true
                },
                {
                    value: "C",
                    text: "중앙 난방",
                    checked: false
                },
                {
                    value: "S",
                    text: "개별 난방",
                    checked: false
                }
            ],

            roomType_options: [{
                    value: "O",
                    text: "원룸",
                    checked: true
                },
                {
                    value: "S",
                    text: "샤워룸",
                    checked: false
                },
                {
                    value: "M",
                    text: "미니룸",
                    checked: false
                }
            ],

            options: [
                // line-1    
                {
                    value: "is_parking",
                    text: "주차장",
                    checked: false
                },
                {
                    value: "is_elevator",
                    text: "엘리베이터",
                    checked: false
                },
                {
                    value: "is_meal",
                    text: "식사 제공",
                    checked: false
                },
                {
                    value: "is_restroom",
                    text: "개별 화장실",
                    checked: false
                },
                {
                    value: "is_kitchen",
                    text: "공용 주방",
                    checked: false
                },

                // line-2
                {
                    value: "is_washroom",
                    text: "공용 세탁기",
                    checked: false
                },
                {
                    value: "is_dry",
                    text: "공용 건조기",
                    checked: false
                },
                {
                    value: "is_cctv",
                    text: "CCTV",
                    checked: false
                },
                {
                    value: "is_double_room",
                    text: "2인실",
                    checked: false
                },
                {
                    value: "is_sprinkler",
                    text: "스프링쿨러",
                    checked: false
                },

                // line-3
                {
                    value: "option_desk",
                    text: "책상",
                    checked: false
                },
                {
                    value: "option_bed",
                    text: "침대",
                    checked: false
                },
                {
                    value: "option_refrigerator",
                    text: "개별 냉장고",
                    checked: false
                },
                {
                    value: "option_fan",
                    text: "선풍기",
                    checked: false
                },
                {
                    value: "option_aircon",
                    text: "개별 에어컨",
                    checked: false
                },

                // line-4
                {
                    value: "option_closet",
                    text: "옷장",
                    checked: false
                },
                {
                    value: "option_wash",
                    text: "개별 세탁기",
                    checked: false
                },
                {
                    value: "option_doorlock",
                    text: "개별 도어락",
                    checked: false
                },
                {
                    value: "option_tv",
                    text: "TV / 모니터",
                    checked: false
                },
                {
                    value: "option_internet",
                    text: "인터넷(WI-FI)",
                    checked: false
                }
            ],

            subwayLine_list: [
                "1", "2", "3", "4", "5", "6", "7", "8", "9",
                "인천1", "인천2", "분당", "신분당", "경의중앙", "공항철도",
                "경춘", "의정부", "용인", "경강", "우이신설", "서해",
                "김포골드", "신림"
            ]
        }
    },
    async mounted() {
        const tooltips = [].slice.call(document.querySelectorAll(".tooltip-wrap"));

        tooltips.forEach((tooltip) => {
            const tooltipSpan = tooltip.querySelector(".tooltip-content");

            tooltip.onmousemove = (e) => {
                tooltipSpan.style.top = `${e.clientY + 10}px`;
                tooltipSpan.style.left = `${e.clientX + 10}px`;
            };
        });
    },
    methods: {
        goToBack() {
            this.$router.push('/');
        },
        openSearchAddress() {
            new daum.Postcode({
                oncomplete: (data) => {
                    const geocoder = new daum.maps.services.Geocoder(); // 주소 -> 좌표 변환 객체 생성

                    geocoder.addressSearch(data.address, (result, status) => {
                        // 주소로 좌표를 검색.
                        if (result.length > 0 && status === daum.maps.services.Status.OK) {
                            // 정상적으로 검색이 완료되었다면.
                            this.kosiwon.lat = result[0].y;
                            this.kosiwon.lng = result[0].x;
                            this.kosiwon.address_brief = data.address;
                        } else {
                            alert("해당 주소는 Daum 지도에 표시되지 않아 위도/경도 값을 가져올 수 없습니다.\n다른 주소로 시도해주세요.");
                        }
                    });
                }
            }).open();
        },

        changeType(type, target) {
            this[target].forEach(option => {
                option.checked = option.value === type.value;
            });
        },
        addSubway() {
            if (this.kosiwon.traffics_subway.length >= 2) {
                alert("지하철 정보는 최대 2개까지 입력 가능합니다.");
            } else {
                this.kosiwon.traffics_subway.push({
                    station_number: "", // 호선 정보 ("1", "2", "신분당"..)
                    intro: "", // 역 이름  ("회기", "역삼", "양재"..)
                    description: "", // ""
                    is_deleted: 0 // 삭제 여부 (0 || 1)
                });
            }
        },
        delSubway(idx) {
            if (confirm("지하철 정보를 삭제하시겠습니까?")) {
                this.kosiwon.traffics_subway.splice(idx, 1);
            }
        },
        imageUploadLoading(flag) {
            if (flag) {
                document.querySelector(".loading-wrap").classList.add("on");
                document.querySelector("body").classList.add("loading");

            } else {
                document.querySelector(".loading-wrap").classList.remove("on");
                document.querySelector("body").classList.remove("loading");
            }
        },
        openUpload(type) {
            document.getElementById(type).click();
        },
        async selectThumbnailImage(event) {
            const file = event.target.files[0];
            const sendData = new FormData();

            if (!file) {
                return;
            }

            if (!file.type.includes("image")) {
                alert("썸네일은 이미지 파일만 등록 가능합니다.");
                return;
            }

            this.imageUploadLoading(true);
            sendData.append("filedata", file);
            try {
                const result = await this.axios.post("/upload/tempUpload", sendData);
                this.kosiwon.thumbnail_url = result.data[0];
            } catch (err) {
                console.log(err);
                alert("이미지 업로드 중 예기지 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.imageUploadLoading(false);
            }
        },
        delThumbnailImage() {
            if (confirm("고시원 썸네일 이미지를 삭제하시겠습니까?")) {
                this.kosiwon.thumbnail_url = null;
            }
        },
        async selectKosiwonImage(event, idx) {
            const files = event.target.files;
            const sendData = new FormData();

            if (!files) {
                return;
            }

            const total = files.length + this.kosiwon_image_files.length;

            if (total > 10) {
                alert("고시원 사진은 최대 10장까지 사진 첨부가 가능합니다.");
                return;
            }

            this.imageUploadLoading(true);
            for (let i = 0; i < files.length; i++) {
                if (!files[i].type.includes("image")) {
                    alert("그룹 파일에는 이미지 파일만 등록 가능합니다.");
                    return;
                } else {
                    sendData.append("filedata", files[i]);
                }
            }

            if (idx >= 0) {
                try {
                    const result = await this.axios.post("/upload/tempUpload", sendData);

                    this.kosiwon_image_files[idx].image_url = result.data[0];
                    this.kosiwon_image_files[idx].vertical = false;
                    this.imgSizeCheck(this.kosiwon_image_files[idx]);
                } catch (err) {
                    console.log(err);
                    alert("이미지 업로드 중 예기지 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
                } finally {
                    this.imageUploadLoading(false);
                }
            } else {
                try {
                    const result = await this.axios.post("/upload/tempUpload", sendData);
                    for (let i = 0; i < result.data.length; i++) {

                        const obj = {
                            image_url: result.data[i],
                            vertical: false
                        };

                        this.kosiwon_image_files.push(obj);
                        this.imgSizeCheck(obj);
                    }
                } catch (err) {
                    console.log(err);
                    alert("이미지 업로드 중 예기지 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
                } finally {
                    this.imageUploadLoading(false);
                }
            }
        },
        delKosiwonImage(idx) {
            if (confirm("해당 이미지를 삭제하시겠습니까?")) {
                this.kosiwon_image_files.splice(idx, 1);
            }
        },
        imgSizeCheck(item) {
            const img = new Image();
            img.src = item.image_url;

            img.onload = () => {
                item.vertical = img.width < img.height;
            };
        },
        async saveKosiwon() {
            if (this.kosiwon.name.trim() === "") {
                this.kosiwon.name = "";
                alert("고시원명을 입력해주세요.");
                $("#name").addClass("error");
                return;
            } else {
                $("#name").removeClass("error");
            }

            if (this.kosiwon.address_brief.trim() === "") {
                this.kosiwon.address_brief = "";
                alert("주소를 입력해주세요.");
                $("#address_brief").addClass("error");
                return;
            } else {
                $("#address_brief").removeClass("error");
            }

            if (this.kosiwon.address_detail.trim() === "") {
                this.kosiwon.address_detail = "";
                alert("상세 주소를 입력해주세요.");
                $("#address_detail").addClass("error");
                return;
            } else {
                $("#address_detail").removeClass("error");
            }

            if (this.kosiwon.owner_name.trim() === "") {
                this.kosiwon.owner_name = "";
                alert("원장님 성함을 입력해주세요.");
                $("#owner_name").addClass("error");
                return;
            } else {
                $("#owner_name").removeClass("error");
            }

            if (this.kosiwon.company_registration_number.trim() === "") {
                this.kosiwon.company_registration_number = "";
                alert("사업자 번호를 입력해주세요.");
                $("#company_registration_number").addClass("error");
                return;
            } else {
                $("#company_registration_number").removeClass("error");
            }

            if (this.kosiwon.phone_no.trim() === "") {
                this.kosiwon.phone_no = "";
                alert("고시원 유선번호를 입력해주세요.\유선 번호가 없다면 원장님 휴대폰 번호를 입력해주세요.");
                $("#phone_no").addClass("error");
                return;
            } else {
                $("#phone_no").removeClass("error");
            }

            if (this.kosiwon.cellphone_no.trim() === "") {
                this.kosiwon.cellphone_no = "";
                alert("고시원 담당자 휴대폰 번호를 입력해주세요.");
                $("#cellphone_no").addClass("error");
                return;
            } else {
                $("#cellphone_no").removeClass("error");
            }

            if (this.kosiwon.price_min === "" || this.kosiwon.price_min < 0 || this.kosiwon.price_max === "" || this.kosiwon.price_max < 0) {
                alert("최소/최대 금액에 값을 입력해주세요.\n또한 0보다 작은 값은 입력할 수 없습니다.");
                $("#price").addClass("error");
                return;
            } else {
                $("#price").removeClass("error");
            }

            if (this.kosiwon.price_min > this.kosiwon.price_max) {
                alert("최소 금액은 최대 금액보다 클 수 없습니다.");
                $("#price").addClass("error");
                return;
            } else {
                $("#price").removeClass("error");
            }

            if (this.kosiwon.price_min.length > 3 || this.kosiwon.price_max.length > 3) {
                alert("금액의 단위는 만원입니다.\n400,000만원인 경우 40을 입력해주세요.");
                $("#price").addClass("error");
                return;
            } else {
                this.kosiwon.price_min = parseInt(this.kosiwon.price_min);
                this.kosiwon.price_max = parseInt(this.kosiwon.price_max);
                $("#price").removeClass("error");
            }

            if (this.kosiwon.deposit === "" || this.kosiwon.deposit < 0) {
                alert("보증금에 값을 입력해주세요.\n또한 0보다 작은 값은 입력할 수 없습니다.\n보증금이 0일 경우 보증금 없음으로 처리됩니다.");
                this.kosiwon.deposit = 0;
                $("#deposit").addClass("error");
                return;
            } else {
                $("#deposit").removeClass("error");
                if (this.kosiwon.deposit !== null) {
                    this.kosiwon.deposit = parseInt(this.kosiwon.deposit);
                }
            }

            if (this.kosiwon.floor.trim() === "" || this.kosiwon.building_floor.trim() === "") {
                alert("층 수의 값을 올바른 값을 입력해주세요.");
                $("#floor").addClass("error");
                return;
            } else {
                $("#floor").removeClass("error");
            }

            const chcked_options = this.options.filter(item => item.checked)

            if (chcked_options.length <= 0) {
                alert("고시원 옵션을 한 개 이상 선택해주세요.");
                return;
            }

            if (this.kosiwon.intro.trim() === "") {
                alert("고시원 한 줄 소개를 입력해주세요.");
                this.kosiwon.intro = "";
                $("#intro").addClass("error");
                return;
            } else {
                $("#intro").removeClass("error");
            }

            if (this.kosiwon.description.trim() === "") {
                alert("고시원 상세 설명을 입력해주세요.");
                this.kosiwon.description = "";
                $('#description').addClass("error");
                return;
            } else {
                $("#description").removeClass("error");
            }

            if (this.kosiwon.thumbnail_url === null) {
                alert("고시원 썸네일 이미지를 등록해주세요.");
                return;
            }

            if (this.kosiwon_image_files.length <= 0) {
                alert("고시원 사진을 한개 이상 등록해주세요.");
                return;
            }

            for (let i = 0; i < this.kosiwon.traffics_subway.length; i++) {
                console.log(this.kosiwon.traffics_subway[i]);

                const currentSubway = this.kosiwon.traffics_subway[i];

                if (currentSubway.station_number === "" || currentSubway.intro === "") {
                    alert("지하철 호선과 역 이름을 입력해주세요.")
                    return;
                }
            }

            if (confirm("입력하신 내용을 고시락에 등록하시겠습니까?")) {
                this.isLoading = true; // loading css start

                this.kosiwon.options.use_sex_type = this.useSexType_options.find(item => item.checked).value;
                this.kosiwon.heating_type = this.heatingType_options.find(item => item.checked).value;

                const arr = [];
                this.roomType_options.forEach(item => {
                    if (item.checked) {
                        arr.push(item.value);
                    }
                });

                this.kosiwon.room_type = arr.join(",");
                this.options.forEach(option => this.kosiwon.options[option.value] = option.checked);

                for (let i = 0; i < this.kosiwon_image_files.length; i++) {
                    this.kosiwon.categories[0].groups[0].images.push({
                        image_url: this.kosiwon_image_files[i].image_url
                    });
                }

                this.axios.post(`/kosiwons`, this.kosiwon).then(kosiwonResult => {
                    this.axios.post(`/kosiwons/images`, {
                        categoryList: this.kosiwon.categories,
                        kosiwonPk: kosiwonResult.data.pk
                    }).then(() => {
                        this.isLoading = false;
                        alert("정상적으로 등록이 완료 되었습니다.\n내용을 검토하여 신속하게 입력해 주신 연락처로 안내 드리겠습니다.\n감사합니다.");

                        window.location.href = "https://kosirock.com";
                    });
                }).catch(err => {
                    this.isLoading = false;
                    alert("고시원 등록 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
                    console.log(err);
                });

            }
        }
    }
}
</script>

<style scoped>
strong {
    font-weight: 700;
}

.img-vertical {
    width: auto;
    display: block;
    margin: 0 auto;
}

.text-center {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 999;
}
</style>
